import React from 'react';
import { Box, TextField } from '@mui/material';
import { MASKED_PLACEHOLDER } from '../../constants';

const PostgresSourceForm = ({ name, config, errors, onChange, isEdit }) => {
    const handleChange = (field, value) => {
        if (field === 'name') {
            onChange({ name: value, config });
            return;
        }
        const next = { ...config, [field]: value };
        onChange({ name, config: next });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
                fullWidth
                label="Tên hiển thị"
                required
                value={name}
                onChange={(e) => handleChange('name', e.target.value)}
                error={!!errors?.name}
                helperText={errors?.name}
                placeholder="Ví dụ: Postgres Analytics"
            />
            <TextField
                fullWidth
                label="Host"
                required
                value={config?.host ?? ''}
                onChange={(e) => handleChange('host', e.target.value)}
                error={!!errors?.host}
                helperText={errors?.host}
            />
            <TextField
                fullWidth
                label="Port"
                type="number"
                required
                value={config?.port ?? 5432}
                onChange={(e) => handleChange('port', e.target.value)}
            />
            <TextField
                fullWidth
                label="Database"
                required
                value={config?.database ?? ''}
                onChange={(e) => handleChange('database', e.target.value)}
                error={!!errors?.database}
            />
            <TextField
                fullWidth
                label="User"
                required
                value={config?.user ?? config?.username ?? ''}
                onChange={(e) => handleChange('user', e.target.value)}
            />
            <TextField
                fullWidth
                label="Password"
                type="password"
                autoComplete="new-password"
                value={config?.password === '***' || config?.password === MASKED_PLACEHOLDER ? '' : (config?.password ?? config?.passwd ?? '')}
                onChange={(e) => handleChange('password', e.target.value)}
                placeholder={isEdit ? MASKED_PLACEHOLDER : ''}
                helperText={isEdit && 'Để trống nếu không đổi mật khẩu'}
            />
        </Box>
    );
};

export default PostgresSourceForm;
